import { ExpenseType } from "./types";

export const transformExpenseType = (res: any): ExpenseType => ({
  id: res.id,
  name: res.name,
  code: res.code ?? null,
  parentId: res.parentId ?? null,
  appliesTo: res.appliesTo ?? null,
  ordinal: res.ordinal ?? 0,
  parentName: res.parentName ?? null,
  fullName: res.fullName ?? res.name,
  isSystem: res.isSystem ?? false,
});
